import {HTTP} from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const goodsReceivePostStore = {
    namespaced: true,
    state:{
        searchModel:{
            compCode:"",
            DateFrom:"",
            DateTo:"",         
            EntNum:"",           
            TxNumFrom:"",
            TxNumTo:"",
            isPosted: false,
            newOnly: false           
        }
    },
    actions:{
        postInvoice({commit, state}, param){
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/PostTx', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        }
    }
};
export default goodsReceivePostStore;